export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_CREDENTIAL = 'SET_CREDENTIAL'
export const SET_DRIVERS_BY_SHOP = 'SET_DRIVERS_BY_SHOP'



// WEBPACK FOOTER //
// ./src/types/dispatch.js